import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { useAuthContext } from "../../contexts/AuthContext";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { CollaboratorCard } from './CollaboratorCard';

const Wrapper = styled.div`
  width: 390px;
  background-color: var(--lk-bg2);
  box-sizing: content-box;
  height: auto;
  height: 100%;
  flex-direction: column;

  .lk-chat-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px;
    font-size: 16px;
  }

  .lk-close-button {
    width: 48px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  border-radius: 10px;
  }

  .lk-close-button:hover {
    cursor: pointer;
  }

`;


export function Collaborators({
  liveEvent,
  onAdmitCollaborator = () => { },
  ...props
}) {
  const ulRef = useRef(null);
  const [allowChangeRole, setAllowChangeRole] = useState(true);
  const { activeUser } = useAuthContext();

  console.log("!!! SELECTED EVENT IN COLLABORATORS: ", liveEvent);

  useEffect(() => {
    console.log("!!! UPDATED EVENT IN COLLABORATORS: ", liveEvent);
    console.log("!!! ACTIVE USER IN COLLABORATORS: ", activeUser);
    const isHost = liveEvent?.collaborators?.find((collaborator) => collaborator.user?.public_id === activeUser.public_id && (collaborator.role === "host" || collaborator.role === "owner" || collaborator.is_owner));
    setAllowChangeRole(!!isHost);
  }, [activeUser, liveEvent]);


  return (
    <Wrapper {...props}>
      <div className="lk-chat-header">
        Collaborators
        <div className="lk-close-button"
          onClick={() => {
            if (props.onClose) {
              props.onClose();
            }
          }}
        >
          <Icon icon="mdi:close" width="20" height="20" />
        </div>
      </div>

      <div className="lk-list " ref={ulRef}>
        {liveEvent?.collaborators?.map((collaborator, index) => (
          <div key={index} className="lk-list-item">
            <CollaboratorCard collaborator={collaborator} allowChangeRole={allowChangeRole} showRole={false} showStatus={true}
              onAdmitCollaborator={onAdmitCollaborator}
            />
          </div>
        ))}
      </div>
    </Wrapper>
  );
}
